import Loading from '../../../../Dashboards/Common/Loading';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';
import { NormalBirths } from './NormalBirths';
import { CesareanBirths } from './CesareanBirths';
import { PregnantWomen6OrMorePrenatalConsultations } from './PregnantWomen6OrMorePrenatalConsultations';
import { PregnantWomenEarlyPrenatalCapture } from './PregnantWomenEarlyPrenatalCapture';
import { WeightLess25KgxMothersLessThan6PrenatalConsultations } from './WeightLess25KgxMothersLessThan6PrenatalConsultations';
import { PregnantWomen6PrenatalConsultations1To12Weeks } from './PregnantWomen6PrenatalConsultations1To12Weeks';
import { TypesOfBirthMothersAge } from './TypesOfBirthMothersAge';
import { PreNatalConsultations } from './PreNatalConsultations';

export const Charts = () => {
    const { isLoading } = useAttentionChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <TypesOfBirthMothersAge />
                <PreNatalConsultations />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <NormalBirths />
                <CesareanBirths />
                <PregnantWomen6OrMorePrenatalConsultations />
                <PregnantWomenEarlyPrenatalCapture />
                <WeightLess25KgxMothersLessThan6PrenatalConsultations />
                <PregnantWomen6PrenatalConsultations1To12Weeks />
            </div>
        </>
    );
};
